export default __webpack_public_path__ + "static/media/pearl.efa4f661.png";